import { NgxLoggerService } from '@allianz/ngx-logger';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideHttpClientTesting } from '@angular/common/http/testing';
import { Injectable, NgModule, signal } from '@angular/core';
import { NGX_PFE_CONFIGURATION, NgxPfeModuleConfiguration } from './models/ngx-pfe-module-configuration.model';
import { NgxPfeModule } from './ngx-pfe.module';
import { PfeUtilService } from './pfe-util/services/util.service';
import { PfeConfigurationService } from './services/pfe-config-service/config-service.service';
import { PfeModuleConfigurationService } from './services/pfe-module-configuration/pfe-module-configuration.service';
import { PageDefinition } from './services/pfe-page-mapping-service/page-definition';

@Injectable()
export class PfeConfigurationServiceMock extends PfeConfigurationService {
  pfeApplicationConfiguration = {
    pfeConfig: {
      autoCleanStaleState: true,
      enableStateCleaning: true,
    },
  };

  constructor(
    private mockHttp: HttpClient,
    private mockPfeUtilService: PfeUtilService,
    private mockLogger: NgxLoggerService
  ) {
    super(mockHttp, mockPfeUtilService, mockLogger, {
      pagesConfiguration: [],
      navConfiguration: {
        errorPageNavigation: [],
        pages: [],
      },
      appConfiguration: {
        pfeConfig: {
          autoCleanStaleState: true,
          enableStateCleaning: true,
        },
      },
    });
  }
}

export const ngxPfeModuleMockingConfiguration: NgxPfeModuleConfiguration = {
  pageMapping: new Map<string, PageDefinition>(),
  applicationId: 'testing mock',
  configApiEndpoint: '/config/',
  serviceActivatorEndpoint: '/service-activator',
  production: false,
};

@NgModule({
  declarations: [],
  exports: [NgxPfeModule],
  imports: [
    NgxPfeModule.forRoot({
      provide: NGX_PFE_CONFIGURATION,
      useValue: ngxPfeModuleMockingConfiguration,
    }),
  ],
  providers: [
    {
      provide: PfeConfigurationService,
      useClass: PfeConfigurationServiceMock,
    },
    {
      provide: PfeModuleConfigurationService,
      useValue: {
        get pfeModuleConfig() {
          return signal(ngxPfeModuleMockingConfiguration);
        },
      },
    },
    NgxLoggerService,
    provideHttpClient(withInterceptorsFromDi()),
    provideHttpClientTesting(),
  ],
})
export class NgxPfeTestingModule {}
